import type { TalkData } from "content-ui/talks/types";
import type { SubscriptionLevel } from "lib/types";
import { SimpleButton } from "components/simpleButton/simpleButton";

type RsvpButtonProps = {
  talk: TalkData;
  onClickRegister: () => void;
  rsvpSent: boolean;
  userLevel: SubscriptionLevel | undefined;
};

export const RsvpButton = ({
  talk,
  onClickRegister,
  rsvpSent,
  userLevel,
}: RsvpButtonProps) => {
  // Talk Booleans (set in Dato)
  const isOversubscribed = talk.isOversubscribed || false;
  const isMemberOnly = talk.isMemberOnly || false;

  // User Level
  const notLoggedIn = userLevel === "unregistered";
  const isHigherTierMember =
    userLevel === "pro" ||
    userLevel === "plus" ||
    userLevel === "sfs" ||
    userLevel === "member" ||
    userLevel === "startup" ||
    userLevel === "angel";

  const renderButtonCopy = () => {
    if (isOversubscribed) {
      return "Event oversubscribed";
    }
    if (isMemberOnly) {
      if (isHigherTierMember) {
        return "RSVP";
      } else {
        return "Join to RSVP";
      }
    } else {
      if (notLoggedIn) {
        return "Register to RSVP";
      } else {
        return "RSVP";
      }
    }
  };

  return (
    <SimpleButton
      data-testid="talks-registration-cta"
      variant="primary"
      accent="sifted"
      size="lg"
      className="w-full min-w-[220px] md:w-auto"
      onClick={onClickRegister}
      disabled={isOversubscribed || rsvpSent}
    >
      {renderButtonCopy()}
    </SimpleButton>
  );
};
